import { type AngelouCSS, constants, typographyStyles } from "@newsela/angelou";

export const cellDefaultCss: AngelouCSS[] = [
  typographyStyles.textS,
  {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textTransform: "capitalize",
  },
];

export const cellLinkCss: AngelouCSS[] = [
  cellDefaultCss,
  {
    color: constants.colors.ui.neutral[600],
    textTransform: "none",
    padding: 0,
    "& > div": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
];

export const cellExpirationCss = (
  value: number,
  limit?: number,
): AngelouCSS => {
  let color: string = constants.colors.ui.red[700];

  if (limit && value <= limit) {
    color = "inherit";
  }

  return [
    cellDefaultCss,
    {
      textTransform: "none",
      color,
    },
  ];
};
